export const KpiCard = ({ label, value, sub, icon: Icon, testId, accent = "#2563EB", delay = 0 }) => (
  <div className="fade-up rounded-xl border border-slate-200 bg-white p-5 transition-colors hover:border-slate-300" style={{ animationDelay: `${delay}ms` }}>
    <div className="flex items-start justify-between">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
      {Icon && <span className="grid h-8 w-8 place-items-center rounded-lg" style={{ background: `${accent}14`, color: accent }}><Icon className="h-4 w-4" /></span>}
    </div>
    <p className="font-mono-num mt-3 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl" data-testid={testId}>{value}</p>
    {sub && <p className="mt-1 text-xs text-slate-500">{sub}</p>}
  </div>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500 md:text-base">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);
